import axios from 'axios';

export default {
  getAllUpcomingRefillCartDataForView,
  addToCart,
  updateItemQty,
  removeItemFromCart
};

export function getAllUpcomingRefillCartDataForView() {
  return axios.get('/api/refillCart/getAllUpcomingRefillCartDataForView');
}

export function addToCart(params) {
  return axios.post('/api/refillCart/addToCart', params);
}

export function updateItemQty(params) {
  return axios.post('/api/refillCart/updateItemQty', params);
}

export function removeItemFromCart(params) {
  return axios.post('/api/refillCart/removeItemFromCart', params);
}
